export default function convertSecondsToHMS(seconds) {
  let hours = Math.floor(seconds / 3600);
  let minutes = Math.floor((seconds % 3600) / 60);
  let remainingSeconds = parseInt(seconds % 60);
  return `${hours / 10 < 1 ? 0 : ""}${hours}:${
    minutes / 10 < 1 ? 0 : ""
  }${minutes}:${remainingSeconds} `;
}
